import { FC } from "react";
import { LinearProgress, Stack, Typography } from "@mui/material";

export type TotalEmissionsDatasource = {
	name: string;
	value: number | undefined;
};

type Props = {
	from?: TotalEmissionsDatasource;
	to?: TotalEmissionsDatasource;
};

const ComparisonLinearProgress: FC<Props> = ({ from, to }) => {
	const fromName = from?.name;
	const toName = to?.name;

	const fromValue = from?.value ?? 0;
	const toValue = to?.value ?? 0;

	const total = fromValue + toValue;

	const fromPercent = total > 0 ? (fromValue / total) * 100 : 0;
	const toPercent = total > 0 ? (toValue / total) * 100 : 0;

	return (
		<Stack direction="column" height={"100%"} width={"100%"}>
			<Stack direction={"row"} justifyContent={"space-between"} spacing={1} alignItems={"center"}>
				<Typography variant="subtitle1" flex={1}>
					{fromPercent.toFixed(0)}%
				</Typography>
				<LinearProgress
					sx={{ flex: 8, height: "6px", borderRadius: "4px", minWidth: "50px" }}
					variant="determinate"
					value={fromPercent}
					color="secondary"
				/>
				<Typography flex={1} variant="subtitle1" textAlign={"right"}>
					{toPercent.toFixed(0)}%
				</Typography>
			</Stack>
			<Stack spacing={3} direction={"row"} justifyContent={"space-between"}>
				<Typography variant="caption" color="text.secondary">
					{fromName}
				</Typography>
				<Typography variant="caption" color="text.secondary" textAlign={"right"}>
					{toName}
				</Typography>
			</Stack>
		</Stack>
	);
};

export default ComparisonLinearProgress;
